// extracted by mini-css-extract-plugin
module.exports = {"Tr":"ItemList_Tr__2E5o-","ordered":"ItemList_ordered__2ESqV"};